import React, { useState } from 'react';
import { Button } from '@mui/material';
import { FlexContainer } from '@/components/containers/FlexContainer/FlexContainer';
import { useDispatch, useSelector } from 'react-redux';
import { setSearchFormData } from '@/redux/actions/searchFormDataActions';
import IOSPicker from '@/components/reusable/IOSPicker/IOSPicker';
import Label from '@/components/form/Label/Label';
import './DateWheelPicker.scss';

const SearchBar = props => {
  const { languageData, onBack } = props;
  return (
    <FlexContainer className={'SearchBar align-items-end'}>
      <i className="fa fa-chevron-left" onClick={onBack}></i>
      <Label className={'fontWhite text-12 margl10'} onClick={onBack}>
        {languageData === 'EN'
          ? 'Back to space details'
          : 'Volver al detalle de espacio'}
      </Label>
    </FlexContainer>
  );
};

const ReservationDateView = props => {
  const { loading, languageData, goBack, goToReservationTime } = props;
  const currentSearchFormData = useSelector(state => state.searchFormData);
  const [selectedDate, setSelectedDate] = useState(
    currentSearchFormData?.startDate,
  );

  const dispatch = useDispatch();
  const setDateInfo = () => {
    dispatch(
      setSearchFormData({ ...currentSearchFormData, startDate: selectedDate }),
    );
    goToReservationTime();
  };

  return (
    <FlexContainer className="ReservationDateView flex-column padlr10 justify-start items-center bgGradientBlue fontWhite">
      <SearchBar languageData={languageData} onBack={goBack} />
      <FlexContainer className={'flex-column padlr20 margb30 height-950px'}>
        <Label className={'text-20 margt20'}>
          {languageData === 'EN' ? 'Select a Date' : 'Selecciona una fecha'}
        </Label>
        <Label className={'text-14 margtb10'}>
          {languageData === 'EN'
            ? 'Choose the day you would like to book your conference room.'
            : 'Elige el día en que te gustaría reservar tu sala de conferencias.'}
        </Label>

        <FlexContainer className="justify-center margt20">
          <Label className={'text-20 margb10'}>
            {languageData === 'EN' ? 'Set Date' : 'Seleccionar fecha'}
          </Label>
        </FlexContainer>
        <IOSPicker
          setSelectedDate={setSelectedDate}
          selectedDate={selectedDate}
        />

        <FlexContainer
          className={'flex-column margt30 padlr40 text-20 padtb10'}
        >
          <Button
            sx={{
              py: 0.8,
              px: 2.2,
              color: 'white',
              textTransform: 'none',
              fontSize: '18px',
              fontWeight: 'normal',
              border: '1px solid rgba(255,255,255,0.2)',
              '&:disabled': { opacity: 0.7 },
            }}
            type="button"
            disabled={loading}
            onClick={() => setDateInfo()}
          >
            {loading
              ? languageData === 'EN'
                ? 'Loading...'
                : 'Cargando...'
              : languageData === 'EN'
                ? 'Submit'
                : 'Seleccionar'}
          </Button>
        </FlexContainer>
      </FlexContainer>
    </FlexContainer>
  );
};

export default ReservationDateView;
